module.exports = __webpack_public_path__ + "img/pic_administration_order.24b483aa.jpg";